import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    '@/locales', // Путь к папке с нашими json файлами локализации
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export function pluralize(count, [one, few, many]) {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return one; // Именительный единственного
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return few; // Родительный единственного
  }
  return many; // Родительный множественного
}

export const selectedLocale = 'ru';

localStorage.setItem('locale', selectedLocale);

export const languages = Object.getOwnPropertyNames(loadLocaleMessages());

export const i18n = new VueI18n({
  locale: selectedLocale,
  globalInjection: true,
  fallbackLocale: 'ru',
  messages: loadLocaleMessages(),
  silentFallbackWarn: true
});

export default i18n;
